require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/is-iterable.js
 ** module id = 404
 ** module chunks = 1 2 3 10 11 13 14 19 20 21 22 32 34
 **/